import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import SocialIcons from './SocialIcons';
import "../styles/navigation.css";

const Navigation = ({ isHome }) => {
  const [navActive, setNavActive] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [overlayVisible, setOverlayVisible] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 500);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close nav on route change
  useEffect(() => {
    setNavActive(false);
  }, [location]);

  const toggleNav = () => setNavActive(prev => !prev);
  const closeNav = () => setNavActive(false);

  const handleAnimateLink = (e, path) => {
    e.preventDefault();
    setOverlayVisible(true);
    setNavActive(false);
    setTimeout(() => {
      navigate(path);
      setOverlayVisible(false);
    }, 300);
  };

  const isActive = (path) => location.pathname === path;

  return (
    <>
      {/* Transition overlay */}
      <div
        className="overlay-transition"
        style={{ opacity: overlayVisible ? 1 : 0, pointerEvents: overlayVisible ? 'all' : 'none' }}
      />

      {/* Navigation fade top */}
      <div className="navigation-fade" />

      {/* Hamburger icon */}
      <div
        className={`nav-icon${navActive ? ' active' : ''}`}
        onClick={toggleNav}
        aria-label="Toggle navigation"
      >
        <div className="hamburger-bar" />
      </div>

      {/* CTA button */}
      <a
        href="https://mail.google.com/mail/?view=cm&fs=1&to=tthtung274@gmail.com"
        target="_blank"
        rel="noopener noreferrer"
        className="btn nav-cta-btn"
      >
        <span>Get in touch</span>
      </a>

      {/* Social icons */}
      <SocialIcons />

      {/* Black overlay */}
      <div
        className="black-overlay"
        onClick={closeNav}
        style={{ cursor: navActive ? 'pointer' : 'default' }}
      />

      {/* Nav menu */}
      <nav className={navActive ? 'active' : ''}>
        <div
          className="background-image"
          style={{ background: "url('/assets/img/about1.png') center center / cover" }}
        />
        <div className="top-fade" />
        <div className="left-fade" />
        <ul>
          <li className={`big-li${isActive('/') ? ' active' : ''}`}>
            <a href="/" onClick={(e) => handleAnimateLink(e, '/')}>Home</a>
          </li>
          <li className={`big-li${isActive('/games') ? ' active' : ''}`}>
            <a href="/games" onClick={(e) => handleAnimateLink(e, '/games')}>Games</a>
          </li>
          <li className={`big-li${isActive('/about') ? ' active' : ''}`}>
            <a href="/about" onClick={(e) => handleAnimateLink(e, '/about')}>About</a>
          </li>
          <li className={`big-li${isActive('/contact') ? ' active' : ''}`}>
            <a href="/contact" onClick={(e) => handleAnimateLink(e, '/contact')}>Contact</a>
          </li>
        </ul>
      </nav>

      {/* Logo */}
      {isHome ? (
        <Link
          to="/"
          className={`logo-home${scrolled ? '' : ''}`}
          onClick={(e) => handleAnimateLink(e, '/')}
        >
          <h3 className="logo-name">Thanh Tung Tran</h3>
          <img src="/assets/img/logo.png" alt="logo" height="23" />
        </Link>
      ) : (
        <Link to="/" className="logo" onClick={(e) => handleAnimateLink(e, '/')}>
          <img src="/assets/img/logo.png" alt="logo" height="23" />
        </Link>
      )}
    </>
  );
};

export default Navigation;